import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        d: "M5.22 0C4.158 0 3.295.79 3.078 1.878c-1.12.194-1.886 1.004-1.886 2.066v.287C.19 4.915-.03 5.784-.03 6.417c0 .556.158 1.09.462 1.56A2.7 2.7 0 0 0 0 9.444c0 1.035.602 1.984 1.523 2.438C2.153 13.25 3.261 14 4.667 14c1.499 0 2.916-1.418 2.916-2.917v-8.75C7.583.801 6.395 0 5.22 0m1.197 11.083c0 .867-.883 1.75-1.75 1.75-1.016 0-1.722-.526-2.158-1.611a.6.6 0 0 0-.335-.328 1.54 1.54 0 0 1-.573-2.523.585.585 0 0 0-.026-.834l-.069-.062a1.72 1.72 0 0 1-.37-1.059c0-.357.097-.887.925-1.353a.58.58 0 0 0 .297-.508v-.611c0-.649.649-.945 1.25-.945a.584.584 0 0 0 .584-.583c0-.606.36-1.25 1.028-1.25.552 0 1.196.306 1.196 1.167zm6.104-1.88c-.55.523-.854 1.204-.854 1.917 0 .945-.768 1.713-1.714 1.713h-.62a.583.583 0 1 1 0-1.166h.62a.547.547 0 0 0 .547-.547c0-.21.022-.416.057-.62H9.333a.583.583 0 0 1-.583-.583v-3.5c0-.322.261-.584.583-.584a.584.584 0 0 0 .584-.583.584.584 0 0 1 1.166 0c0 .76-.487 1.41-1.166 1.65v2.433h1.047c.194-.354.445-.683.753-.976.965-.918 1.63-2.545.607-4.36-.58-1.026-1.726-1.664-2.99-1.664a.584.584 0 0 1 0-1.166c1.685 0 3.22.865 4.006 2.257 1.116 1.977.795 4.245-.818 5.779"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h14v14H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }